<!-- View Master Add/Edit Modal -->
<div class="modal fade" id="kt_modal_view_master_add_edit" tabindex="-1" aria-hidden="true">
  <!--begin::Modal dialog-->
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <!--begin::Modal content-->
    <div class="modal-content">
      <!--begin::Modal header-->
      <div class="modal-header" id="kt_modal_view_master_add_edit_header">
        <!--begin::Modal title-->
        <h2 class="fw-bold">{{ isEditMode ? 'Edit' : 'Add' }} View Master</h2>
        <!--end::Modal title-->
        <!--begin::Close-->
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body px-5 my-7">
        <!--begin::Form-->
        <form [formGroup]="viewMasterForm" (ngSubmit)="onSubmit()" id="kt_modal_view_master_add_edit_form">
          <!--begin::Scroll-->
          <div class="d-flex flex-column scroll-y px-5 px-lg-10" id="kt_modal_view_master_add_edit_scroll" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_view_master_add_edit_header" data-kt-scroll-wrappers="#kt_modal_view_master_add_edit_scroll" data-kt-scroll-offset="300px">

            <!--begin::Input group - Name-->
            <div class="fv-row mb-7">
              <!--begin::Label-->
              <label class="required fw-semibold fs-6 mb-2">Name</label>
              <!--end::Label-->
              <!--begin::Input-->
              <input type="text"
                     formControlName="name"
                     class="form-control form-control-solid mb-3 mb-lg-0"
                     [class.is-invalid]="isFieldInvalid('name')"
                     placeholder="Enter view master name" />
              <!--end::Input-->
              <!--begin::Error-->
              <div *ngIf="isFieldInvalid('name')" class="invalid-feedback">
                {{ getFieldError('name') }}
              </div>
              <!--end::Error-->
            </div>
            <!--end::Input group-->

            <!--begin::Vehicle Fields Section-->
            <div class="fv-row mb-7">
              <!--begin::Label-->
              <label class="fw-semibold fs-6 mb-2">Vehicle Fields</label>
              <!--end::Label-->
              <!--begin::Checkboxes Grid-->
              <div class="row" formArrayName="vehicle_fields">
                <div class="col-md-4 mb-3" *ngFor="let field of vehicleFields; let i = index">
                  <label class="form-check form-check-sm form-check-custom form-check-solid">
                    <input class="form-check-input"
                           type="checkbox"
                           [formControlName]="i" />
                    <span class="form-check-label fw-semibold text-gray-700 fs-7">
                      {{ field }}
                    </span>
                  </label>
                </div>
              </div>
              <!--end::Checkboxes Grid-->
            </div>
            <!--end::Vehicle Fields Section-->

            <!--begin::Charges Section-->
            <div class="fv-row mb-7">
              <!--begin::Label-->
              <label class="fw-semibold fs-6 mb-2">Charges</label>
              <!--end::Label-->
              <!--begin::Checkboxes Grid-->
              <div class="row" formArrayName="charges">
                <div class="col-md-4 mb-3" *ngFor="let charge of charges; let i = index">
                  <label class="form-check form-check-sm form-check-custom form-check-solid">
                    <input class="form-check-input"
                           type="checkbox"
                           [formControlName]="i" />
                    <span class="form-check-label fw-semibold text-gray-700 fs-7">
                      {{ charge }}
                    </span>
                  </label>
                </div>
              </div>
              <!--end::Checkboxes Grid-->
            </div>
            <!--end::Charges Section-->

          </div>
          <!--end::Scroll-->
        </form>
        <!--end::Form-->
      </div>
      <!--end::Modal body-->
      <!--begin::Modal footer-->
      <div class="modal-footer flex-center">
        <!--begin::Button-->
        <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
        <!--end::Button-->
        <!--begin::Button-->
        <button type="submit"
                class="btn btn-primary"
                [disabled]="isLoading"
                (click)="onSubmit()">
          <span *ngIf="!isLoading" class="indicator-label">
            {{ isEditMode ? 'Update' : 'Save' }}
          </span>
          <span *ngIf="isLoading" class="indicator-progress">
            Please wait...
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </button>
        <!--end::Button-->
      </div>
      <!--end::Modal footer-->
    </div>
    <!--end::Modal content-->
  </div>
  <!--end::Modal dialog-->
</div>
